export function tokenizeOmnisearchQueryText(queryText: string): string[] {
    const rawTokens: string[] = queryText
        .trim()
        .split(/\s+/)
        .filter((token) => token.length > 0);
    const seenNormalizedTokens: Set<string> = new Set<string>();
    const dedupedTokens: string[] = [];

    for (const token of rawTokens) {
        const normalizedToken: string = token.toLowerCase();
        if (seenNormalizedTokens.has(normalizedToken)) {
            continue;
        }
        seenNormalizedTokens.add(normalizedToken);
        dedupedTokens.push(token);
    }

    return dedupedTokens;
}
